import React from 'react';
import '../css/Footer.css';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <div className="FooterContainer">
      <div className="gerneral-info">
        <p>Address: <br />Shop No 3, Shikshak Bhavan,<br /> College Road, Belagavi, Karnataka-590001</p>
        <p>Email: aquatreatuf@yahoo.co.in<br /> Contact: +91 9448185916</p>
      </div>
      <p className="FooterCopyright">
        Copyright {new Date().getFullYear()} @aquatreatsystems || Designed Developed by: Adnan Sattikar
      </p>
     
      <nav className="FooterNav">
        <Link to="/terms" className="FooterNavItem">
          Terms of Use
        </Link >
        <Link to="/privacy" className="FooterNavItem">
          Privacy Policy
        </Link >
      </nav>

    </div>
  );
};

export default Footer;
